import { Api } from 'common/utils/api';
import { useMutation, useQueryClient } from 'react-query';

export interface UpdateCompanyRequest {
    id: number;
    name: string;
}

export const useUpdateCompany = () => {
    const queryClient = useQueryClient();

    const updateCompany = useMutation((data: UpdateCompanyRequest) => Api.put({ path: `/partners/${data.id}`, body: data }), {
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['partners', 'list'] });
        },
    });
    return {
        updateCompany: updateCompany.mutateAsync,
    };
};
